module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_01@2x-7ff586976628a2f9f46de3a275f8745d.webp";